import { ReactElement } from "react";
import styled from "styled-components";
import facebook from "../../assets/facebook.webp";
import instagram from "../../assets/instagram.webp";
import logo from "../../assets/logo-branco.webp";
import whatsapp from "../../assets/whatsapp.svg";

const Container = styled.footer`
  background: #084f43;
  display: flex;
  gap: 48px;
  padding: 48px 60px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 32px;
    padding: 32px 24px;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 220px;
`;

const Logo = styled.img`
  height: auto;
  width: 160px;
`;

const CompanyName = styled.p`
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
`;

const PrivacyLink = styled.a`
  color: #fff;
  font-size: 14px;
  text-decoration: underline;
  width: fit-content;

  &:hover {
    opacity: 0.75;
  }
`;

const SocialRow = styled.div`
  display: flex;
  gap: 14px;
  margin-top: 4px;
`;

const SocialAnchor = styled.a`
  display: flex;
`;

const SocialIcon = styled.img`
  height: 20px;
  width: 20px;
  margin-top: 5px;
`;

const Disclaimer = styled.p`
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  line-height: 1.7;
`;

export function FooterSuccess(): ReactElement {
  return (
    <Container>
      <Left>
        <Logo src={logo} alt="Cartão de TODOS" />
        <CompanyName>TODOS Empreendimentos LTDA</CompanyName>
        <PrivacyLink
          href="https://www.cartaodetodos.com.br/politica-de-privacidade/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Políticas de Privacidade
        </PrivacyLink>
        <SocialRow>
          <SocialAnchor
            href="https://www.instagram.com/cartaodetodosbrasil/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={instagram} alt="Instagram" />
          </SocialAnchor>
          <SocialAnchor
            href="https://www.facebook.com/cartaodetodosbrasil/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={facebook} alt="Facebook" />
          </SocialAnchor>
          <SocialAnchor
            href="https://api.whatsapp.com/send?phone=551140037537&text=Ol%C3%A1,%20gostaria%20de%20saber%20mais%20sobre%20o%20Cart%C3%A3o%20de%20TODOS"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SocialIcon src={whatsapp} alt="WhatsApp" />
          </SocialAnchor>
        </SocialRow>
      </Left>
      <Disclaimer>
        *Cartão de desconto não é plano de saúde, não garante e não se
        responsabiliza pelos serviços oferecidos e pelo pagamento das despesas,
        nem assegura desconto em todos os serviços obrigatoriamente garantidos
        por plano de saúde. Tudo o que o cliente usar ou comprar será por ele
        pago ao prestador, assegurando-se apenas os preços e descontos que
        constam na relação de empresas e serviços conveniados disponibilizados
        no site www.cartaodetodos.com.br. O atendimento será em até 15 dias,
        mediante disponibilidade na clínica. Consulte a clínica parceira para as
        áreas médicas disponíveis e condições para marcar as consultas
      </Disclaimer>
    </Container>
  );
}
